import { padZeroLeft } from '@synergy/utils';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

export interface PoolDocumentTypeProps {
    titleTranslationId: string;
    id?: number | null;
    hasId?: boolean;
    name?: string;
}

export const PoolDocumentTitle = (props: PoolDocumentTypeProps): null => {
    const { titleTranslationId, id, name, hasId = false } = props;

    const intl = useIntl();

    useEffect(() => {
        const translatedTitle = intl.formatMessage({ id: titleTranslationId });
        const fullTitle = [
            translatedTitle,
            hasId ? (id ? padZeroLeft(id, 5) : intl.formatMessage({ id: 'app.common.new' })) : undefined,
            name,
        ]
            .filter(Boolean)
            .join(' - ');

        document.title = fullTitle;
    }, [titleTranslationId, id, name, hasId, intl]);

    return null;
};
